import { useNode } from '@craftjs/core';
import { FormTagInputComponent } from 'src/features/generalForms/builder/types/TagInput';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { HookFormTagInputField } from 'src/features/generalForms/uikit/hookFormFields/hookFormTagInputField';

export const FormTagInput: FormTagInputComponent = (props) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.UiKit.Validation');
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));

  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  // Custom validation for new tag, not for array of tags
  const validateNewTagValueHandler = useCallback(
    (newTag: string) => {
      if (!props.pattern) return true;

      const regexValue = new RegExp(props.pattern);
      const isValid = regexValue.test(newTag);
      if (!isValid) {
        form.setError(props.dataKey!, {
          message: t('WrongPattern', { pattern: props.pattern }),
          type: 'pattern',
        });
      } else {
        form.clearErrors(props.dataKey);
      }

      return isValid;
    },
    [form, props.dataKey, props.pattern, t],
  );

  if (!visible) {
    return <></>;
  }

  return (
    <div style={{ ...styles, boxSizing: 'border-box' }}>
      <HookFormTagInputField
        control={form.control}
        name={props.dataKey!}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        disabled={isDisabled}
        canAddTagValidationCallback={validateNewTagValueHandler}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
        })}
        placeholder={props.placeholder}
        errorProps={{ errors }}
        defaultValue={props.defaultValue}
      />
    </div>
  );
};
